// extracted by mini-css-extract-plugin
export default {"wrapper":"Featured_wrapper__eQKnc","container":"Featured_container__BC5vi","title":"Featured_title__u00Wa"};